export enum WorklistStatus {
	InProcess,
	Ignore,
	Active,
	Done
}